import React from 'react';
import { MdClose, MdWarning } from 'react-icons/md';

import PropTypes from 'prop-types';
import styled from 'styled-components';

// Modal de confirmacao para inativacao terminal de unit. Operacao permanente:
// (a) unidade nao pode ser reativada via API;
// (b) todos os vendedores vinculados sao desvinculados;
// (c) pedidos em andamento na unit bloqueiam a inativacao.
// Doc: docs/FEAT-007_inativacao-terminal-units.md
function InactivateUnitModal({ id_modal, unit, onConfirm }) {
  return (
    <Modal>
      <div className="modal" tabIndex="-1" id={id_modal}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title col-11">
                <MdWarning style={{ marginTop: '-3px', marginRight: '6px' }} />
                INATIVAR UNIDADE
              </h5>
              <MdClose size={30} data-bs-dismiss="modal" type="button" />
            </div>
            <div className="bg-modal">
              <div className="modal-body">
                <p className="text-danger fw-bold text-uppercase mb-3">
                  Atenção: esta ação é permanente.
                </p>
                <ul className="text-start small">
                  <li>
                    A unidade <b>{unit?.name}</b>{' '}
                    <b>não poderá ser reativada</b>. Para reabrir este ponto de
                    operação no futuro, será necessário cadastrar uma nova
                    unidade.
                  </li>
                  <li>
                    <b>Todos os vendedores vinculados serão desvinculados</b>{' '}
                    automaticamente.
                  </li>
                  <li>
                    Pedidos em andamento na unidade <b>bloqueiam</b> a
                    inativação. Conclua ou arquive antes.
                  </li>
                </ul>
                <p className="mt-3 mb-0">
                  Confirmar inativação de <b>{unit?.name}</b>?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary col-4"
                  data-bs-dismiss="modal"
                >
                  CANCELAR
                </button>
                <button
                  type="button"
                  className="btn btn-danger col-5"
                  data-bs-dismiss="modal"
                  onClick={() => onConfirm()}
                >
                  INATIVAR PERMANENTEMENTE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

InactivateUnitModal.propTypes = {
  id_modal: PropTypes.string.isRequired,
  unit: PropTypes.shape().isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default InactivateUnitModal;

export const Modal = styled.div`
  .bg-modal {
    background-color: #f5f5f5;
    margin: 7px;
  }

  .modal-header {
    border: none;
    background-color: #b02a37;
    color: #fff;
    justify-content: center !important;
  }

  .modal-body {
    text-transform: none;
  }

  .modal-footer {
    justify-content: center !important;
    border: none;
  }

  svg {
    :hover {
      cursor: pointer;
      color: #ffba00;
    }
  }
`;
